import { createSelector } from "reselect";

const ofertaReducerSelector = (state) => state.ofertaReducer.getIn(["data"]).toJS();
export const ofertaSelector = createSelector(ofertaReducerSelector, (dataField) => {
  return dataField;
});

const oferta = (state) => state.OfertaReducer.getIn(["oferta"]);
export const ofertaEditadoSelector = createSelector(oferta, (dataField) => {
  return dataField.toJS ? dataField.toJS() : dataField;
});
